import AddPlayerToTeamSeasonMutation from "./AddPlayerToTeamSeason";

export default function InviteLeagueCoordinatorMutation() {
    return AddPlayerToTeamSeasonMutation();
}




